import React from 'react'
import Button from '../../Button/Button'
import { Modal } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { selectNextTokenModalStyles as styles } from './SelectNextTokenModalStyles.tailwind'

const SelectNextTokenModal = ({ isOpen, onClose, nextTokenId, setSelectedTokenId, setTokenData, setHasUnsavedChanges  }) => {
  const handleContinue = () => {
    // Clear the current token data (selected images, deployment status, etc.)
    setTokenData([
      {
        tokenIndex: 0,
        selectedImages: { actionImage: null, playerImage: null },
      },
    ]);
  
    setHasUnsavedChanges(false);
    // Set the selected token to the next token
    setSelectedTokenId(nextTokenId);
    
    // Close the modal
    onClose();
  };
  
  return (
    <Modal
      open={isOpen}
      onClose={() => { }} // Prevent closing when clicking outside
      disableAutoFocus
    >
    <div className={styles.container}>
      <button onClick={onClose} className={styles.closeIcon}>
        <CloseIcon sx={{ fontSize: "18px" }} />
      </button>

      <div className={styles.heading}>Discard Power-Up?</div>

      <div className={styles.description}>
        <span className={styles.confirmationText}>Are you sure you want to skip the Power Up process for this token? All current selections will be discarded.</span>
      </div>

      <div className={styles.buttonContainer}>
        <Button variant="lighttheme" onClick={onClose} className={styles.button}>
          Cancel
        </Button>
        <Button variant="primary" className={styles.button} onClick={handleContinue}>
          Continue
        </Button>
      </div>
    </div>
  </Modal>
  )
}

export default SelectNextTokenModal